import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import AssignmentPopupContainer from '../containers/AssignmentPopupContainer/index';
import NgssSearchFormContainer from '../containers/NgssSearchFormContainer/index';
import NgssSearchForm from './NgssSearchForm';
import { formatKeysToCamelCase, formatStudentKeysToCamelCase } from '../util'

//const ModuleSearch = ({ module, onlyQuests, includePractice, includeEnrichment, handleCardClick }) => {
class ModuleSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAssignmentPopupVisible: false,
      questData: ''
    }
  }

  titleText = ()=> {
    const { controls, includePractice, includeEnrichment } = this.props

    if(!controls && includePractice){ return 'Practice Quests'; }
    else if(!controls && includeEnrichment){ return 'Enrichment Quests'; }
    else{ return 'Search Module'; }
  }

  getQuests = ()=> {
    const { controls, module, includePractice, includeEnrichment } = this.props

    const sequenceQuests = _.uniq(_.flatMap(module.sequences, sequence=>sequence.quests))

    let completeQuests = _.compact(_.map(module.quests, quest =>
      quest.in_progress ? '' : quest
    ))

    if(includePractice){
      _.remove(completeQuests, quest => quest.ngss_enrichment)
    } else if(includeEnrichment) {
      _.remove(completeQuests, quest => !quest.ngss_enrichment)
    }

    return _.sortBy(completeQuests, quest => quest.name)
  }

  handleCardClick = content => {
    this.setState({
      isAssignmentPopupVisible: true,
      questData: content.type === 'quests' ? formatKeysToCamelCase(content) : '',
      sequenceData: content.type === 'sequences' ? formatKeysToCamelCase(content) : ''
    })
  }

  handleCardClose = ()=> {
    this.setState({
      isAssignmentPopupVisible: false,
      questData: '',
      sequenceData: ''
    })
  }

  render() {
    const { studentGroupingsProps: { collection }, contentTypes, controls, module, includePractice, includeEnrichment, handleCardClick } = this.props
    formatStudentKeysToCamelCase(collection)
    return(
      <div className='module-subpage module-overview'>
        <h1><span className="semi-bold">{this.titleText()}</span></h1>
        {!controls && includePractice &&
          <p>These quests are additional quests that cover the Module Standards. They are suggested for extra practice for students who need some additional time with a concept.</p>
        }
        {!controls && includeEnrichment &&
          <p>These quests are additional quests that go beyond the Module Standards. They are suggested for students who are ready for advanced differentiation.</p>
        }
        {controls &&
          <p>This search includes all Storylines, Quests within the Genetics & Growth Module.</p>
        }
        <br/>

        <NgssSearchFormContainer searchAll={controls} initialValues={{ includeEnrichment, includeNonEnrichment: includePractice, contentTypes }}>
          <NgssSearchForm controls={controls} handleCardClick={this.handleCardClick}/>
        </NgssSearchFormContainer>

        {this.state.isAssignmentPopupVisible &&
          <AssignmentPopupContainer
            assignableContent={this.state.questData || this.state.sequenceData}
            studentGroupings={collection}
            handleClose={this.handleCardClose}
            questId={(this.state.questData || {}).id}
            sequenceId={(this.state.sequenceData || {}).id}
            usingDeletionForm={false}
          />
        }
      </div>
    );
  }
}

export default ModuleSearch;
